export default __webpack_public_path__ + "static/holographic-1e856bbcda59cf7b9a73af19aa327fda.jpg";